<div class="bg-gray-200 rounded-2 p-2 mt-2">
  <div class="row gy-2">
    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Operating Unit</label>
      <ng-select
        [items]="organizations()"
        class="ng-select ng-select-md"
        [searchable]="true"
        bindLabel="oUnitCode"
        bindValue="id"
        [clearable]="true"
        placeholder="Select Operating Unit"
        [(ngModel)]="selectedOrganization"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.oUnitCode | titlecase }}</span>
            <small class="text-muted">{{ item.name | titlecase }}</small>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.oUnitCode | titlecase }}</span>
            <small class="text-muted">{{ item.name | titlecase }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Projects</label>
      <ng-select
        [items]="projects()"
        [searchable]="true"
        bindLabel="projCode"
        bindValue="id"
        class="ng-select ng-select-md"
        [clearable]="true"
        placeholder="Select Project"
        [(ngModel)]="selectedProject"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.projCode | titlecase }}</span>
            <small class="text-muted">{{ item.projectName | titlecase }}</small>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.projCode | titlecase }}</span>
            <small class="text-muted">{{ item.projectName | titlecase }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Lots</label>
      <ng-select
        [items]="lots()"
        [searchable]="true"
        bindLabel="lotNo"
        bindValue="id"
        class="ng-select ng-select-md"
        [clearable]="true"
        placeholder="Select Lot"
        [(ngModel)]="selectedLots"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.lotNo | titlecase }}</span>
            <small class="text-muted">{{ item.buyerName | titlecase }}</small>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.lotNo | titlecase }}</span>
            <small class="text-muted">{{ item.buyerName | titlecase }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Schedule</label>
      <ng-select
        [items]="schedule()"
        [searchable]="true"
        bindLabel="code"
        bindValue="id"
        class="ng-select ng-select-md"
        [clearable]="true"
        placeholder="Select Schedule"
        [(ngModel)]="selectedSchedule"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.code | titlecase }}</span>
            <small class="text-muted">{{ item.name | titlecase }}</small>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.code | titlecase }}</span>
            <small class="text-muted">{{ item.name | titlecase }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Task</label>
      <ng-select
        [items]="tasks()"
        class="ng-select ng-select-md"
        [searchable]="true"
        bindLabel="taskName"
        bindValue="id"
        [clearable]="true"
        placeholder="Select Task"
        [(ngModel)]="selectedTask"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.taskCode | titlecase }}</span>
            <small class="text-muted">{{ item.taskName | titlecase }}</small>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.taskCode | titlecase }}</span>
            <small class="text-muted">{{ item.taskName | titlecase }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Stages</label>
      <ng-select
        [items]="stages()"
        class="ng-select ng-select-md"
        [searchable]="true"
        bindLabel="code"
        bindValue="id"
        [clearable]="true"
        placeholder="Select Stage"
        [(ngModel)]="selectedStage"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.code | titlecase }}</span>
            <small class="text-muted">{{ item.name | titlecase }}</small>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex flex-column">
            <span>{{ item.code | titlecase }}</span>
            <small class="text-muted">{{ item.name | titlecase }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Status</label>
      <ng-select
        [items]="statuses()"
        [searchable]="true"
        bindLabel="name"
        bindValue="id"
        class="ng-select ng-select-md"
        placeholder="Select status"
        [(ngModel)]="selectedStatus"
        [clearable]="false"
      >
      </ng-select>
    </div>
    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Sort By</label>
      <ng-select
        [items]="sortBy()"
        [searchable]="true"
        bindLabel="name"
        bindValue="id"
        class="ng-select ng-select-md"
        placeholder="Select Status"
        [(ngModel)]="selectedSortBy"
      >
      </ng-select>
    </div>
    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Sort Order</label>
      <ng-select
        [items]="orderType()"
        [searchable]="true"
        bindLabel="name"
        bindValue="id"
        class="ng-select ng-select-md"
        placeholder="Select Order By"
        [(ngModel)]="selectedOrder"
        [clearable]="false"
      >
      </ng-select>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Schedule From Date</label>
      <p-datepicker styleClass="w-100" placeholder="Schedule From Date"></p-datepicker>
    </div>

    <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
      <label class="form-label">Schedule To Date</label>
      <p-datepicker styleClass="w-100" placeholder="Schedule To Date"></p-datepicker>
    </div>
  </div>
</div>
